import type { MdbaseConnectionInfo } from "@mdbase-dev/connect";

export const flowLevels = ["none", "spotting", "light", "medium", "heavy"] as const;
export const symptomNames = [
  "cramps",
  "headache",
  "bloating",
  "tenderness",
  "backache",
  "acne",
  "nausea",
  "fatigue",
] as const;
export const moodNames = [
  "steady",
  "sensitive",
  "low",
  "irritable",
  "anxious",
  "energised",
] as const;
export const energyLevels = ["low", "medium", "high"] as const;

export type Flow = (typeof flowLevels)[number];
export type Symptom = (typeof symptomNames)[number];
export type Mood = (typeof moodNames)[number];
export type Energy = (typeof energyLevels)[number];

export interface CycleDay {
  path: string;
  revision?: string;
  contractType?: string;
  date: string;
  flow: Flow;
  symptoms: Symptom[];
  pain: number;
  mood: Mood;
  energy: Energy;
  sleep_quality: number;
  notes: string;
  updated_at: string;
}

export type CycleDayInput = Omit<
  CycleDay,
  "path" | "revision" | "contractType" | "updated_at"
>;

export interface CycleRepository {
  list(): Promise<CycleDay[]>;
  save(input: CycleDayInput, existing?: CycleDay): Promise<CycleDay>;
}

export interface ConnectionDetails {
  info: MdbaseConnectionInfo;
  checkDirectAccess(): Promise<void>;
  requestDirectAccess(): Promise<void>;
  switchCollection(): void;
  forgetCollection(): void;
}
